import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import ArrowBack from '../../common/images-new/arrow-back-black-icon.svg'
import ButtonHashtag from "../../components/Button/ButtonHashtag";
import Comment from '../../components/LikeComment/Comment'
import AvatarGroup from '../../components/LikeComment/AvatarGroup'
import LikeComment from '../../components/LikeComment/LikeComment';
import PageWrapper from '../PageWrapper'
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import { useParams } from 'react-router-dom';
import moment from "moment";
import axios from 'axios';
import { apiUrl, serverUrl } from '../../components/Helpers/Config';
import { getProfilePic, convertDate, addAttribute } from '../../components/Helpers/Common';
import readingTime from 'reading-time'
import CommentInput from '../../components/LikeComment/CommentInput';
import { staticFiles } from '../../components/Helpers/Static';
import {
  ActiveIconColor,
  BgWhite,
  ButtonCommonTop,
  ButtonCommonTopNew,
  Card,
  DivBadge,
  TextGray,
} from "../Theme";
import { BiLeftArrowAlt } from "react-icons/bi";
import { MdDescription, MdKeyboardArrowLeft } from 'react-icons/md';
import { tokenAuthorize } from '../../components/Helpers/Common';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { CommonLoader } from '../../components/Button/Loader';
const FILE_UPLOAD = staticFiles.fileUpload;
const NO_IMAGE = staticFiles.noImage;

const formatModernDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short", // Jan, Feb, Mar, etc.
      day: "numeric", // 1, 2, 3...
    });
  };

const AnnounceView = (props) => {

    const history = useHistory();
    const location = useLocation();

    const groupId = location.state.id;

    const { id } = useParams()
    const userId = localStorage.getItem('user_id')
    const userProfile = useSelector(state => state.auth.user)
    const profile = {
        name: userProfile ? userProfile.fullname : '',
        photo: userProfile ? userProfile.photo : hmenu_user,
    }

    const [isLoad, setisLoad] = useState(false)
    const [announcementTitle, setannouncementTitle] = useState("");
    const [announcementDesc, setannouncementDesc] = useState("");
    const [announcementAttachment, setannouncementAttachment] = useState([]);
    const [announcementCreatedOn, setannouncementCreatedOn] = useState("");
    const [announcementFullName, setannouncementFullName] = useState("");
    const [guId, setguId] = useState("");

    useEffect(() => {
        setisLoad(true)
        getAnnouncement();
    }, [])

    const goBack = () => {
        history.goBack();
    }

    const getAnnouncement = () => {
        return axios.get(
            `${apiUrl}${groupId}/announcement/${id}`
        ).then(resp => {
            if (resp.status === 200) {
                let data = [];
                setannouncementAttachment(resp.data?.announcement_attachment)
                setannouncementDesc(resp.data?.announcement_desc)
                setannouncementTitle(resp.data?.announcement_title)
                setannouncementCreatedOn(resp.data?.announcement_created_on)
                setannouncementFullName(resp.data?.fullname)
                setguId(resp.data?.guid)
            }
            setisLoad(false)
        }).catch(err => {
            setisLoad(false)
            tokenAuthorize(err?.response?.status);
            if (err.response && (err.response.status === 404)) {
                history.push('/post-not-found');
            }
            else {
                console.log(err)
            }
        })
    }
    const minutesRead = announcementDesc ? readingTime(announcementDesc).text : null;
    return (
        <PageWrapper>
            <div className="border20px overflow-hidden cardBackgroundColor py-6 relative shadow-md">
 {/* <Card className="cardBackgroundColor border20px shadow-md mb-2 h-full flex flex-col py-6"> */}
                {isLoad ?
                    <div className='w-full flex justify-center'>
                        <CommonLoader/>
                    </div> :
                    <>
                        <div className="flex flex-col px-6 mb-4">
                            <div className="relative flex items-center justify-between gap-1">
                            {/* <ButtonCommonTopNew
                                className={`rounded-lg px-5 py-2 flex items-center w-max cursor-pointer`}
                                onClick={goBack}
                            >
                                <BiLeftArrowAlt className="w-5 h-5" />
                                <h1 className="text-xs lg:text-sm">Back</h1>
                            </ButtonCommonTopNew> */}
                              <div
                                className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                                onClick={goBack}
                            >
                                <KeyboardBackspaceIcon className="text-3xl primaryIcon"/>
                                <h1 className="text-lg blueColor font-semibold">Back</h1>
                            </div>
                               
                                {/* <p className="sm:absolute sm:left-1/2 sm:transform sm:-translate-x-1/2 sm:block w-full sm:w-max  text-xl  flex justify-center items-center font-semibold blackColor">{announcementTitle}</p> */}
                             <p className="text-xl font-semibold blackColor">{announcementTitle}</p>

                            <div className='hidden sm:block' style={{ width: '90px' }} />
                            </div>
                            <div className="flex flex-row gap-2 lg:flex-row pt-4 mb-4 md:mb-4 items-center relative ">
                                <img
                                    className="h-10 w-10 rounded-full"
                                    src={profile.photo}
                                    alt="profile"
                                ></img>
                                <div className="flex flex-col mr-10 text-left">
                                    <div className="flex blackColor gap-1">
                                        by
                                    <Link
                                        to={"/profile/" + guId}
                                        target="_blank" rel="noopener noreferrer"
                                        className="break-words nav-navigate"
                                    >
                                        <ActiveIconColor className='hover:underline text-base font-semibold'>{announcementFullName}</ActiveIconColor>
                                    </Link>
                                    </div>
                                     <span className="lightColor text-sm flex items-center">
                                        {moment.utc(announcementCreatedOn).local().startOf('seconds').fromNow()} ({formatModernDate(announcementCreatedOn)}) - {minutesRead}
                                    </span>
                                </div>
                            </div>

                            {
                                announcementAttachment &&
                                (
            <div className="flex flex-wrap w-full gap-2">
                                {announcementAttachment.map((item, idx) => {
                                    let itemName = item ? item : null
                                    if (itemName) {
                                        const itemUrl = itemName;
                                        const lastSlash = itemName.lastIndexOf('/');

                                       if (lastSlash !== -1) {
                                                itemName = itemName.substr(
                                                lastSlash + 1,
                                                itemName.length - lastSlash - 1
                                                );
                                               itemName = itemName.includes("-")
                                                ? itemName.substring(itemName.indexOf("-") + 1)
                                                : itemName;
                                            }
                                             
                                        return (
                                             <DivBadge
                                            key={idx}
                                            className="flex flex-row items-center rounded-lg px-2 justify-center w-max"
                                            >
                                            <MdDescription className="w-5 h-5 text-white" />
                                            <a
                                                href={itemUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="flex text-sm p-1 nav-navigate"
                                            >
                                                <div className=" text-white">{itemName}</div>
                                            </a>
                                            </DivBadge>
                                        )
                                    }

                                    return null;
                                })}
                                   </div>
          )}
                            

                        </div>
                        <div  className="px-6 pt-4 break-words"
                            dangerouslySetInnerHTML={{ __html: addAttribute(announcementDesc) }}
                        />
                    </>}

                {/* <hr className="self-center w-3/4 mx-10 lg:mx-40 rm" /> */}
            {/* </Card> */}
            </div>

        </PageWrapper>
    )
}

export default AnnounceView;

// import React, { useEffect, useState } from 'react'
// import { useSelector } from "react-redux";
// import { Link, useHistory, useLocation } from "react-router-dom";
// import ArrowBack from '../../common/images-new/arrow-back-black-icon.svg'
// import ButtonHashtag from "../../components/Button/ButtonHashtag";
// import Comment from '../../components/LikeComment/Comment'
// import AvatarGroup from '../../components/LikeComment/AvatarGroup'
// import LikeComment from '../../components/LikeComment/LikeComment';
// import PageWrapper from '../PageWrapper'
// import hmenu_user from "../../common/images-new/no-profile-pic.png";
// import { useParams } from 'react-router-dom';
// import moment from "moment";
// import axios from 'axios';
// import { apiUrl, serverUrl } from '../../components/Helpers/Config';
// import { getProfilePic, convertDate, addAttribute } from '../../components/Helpers/Common';
// import readingTime from 'reading-time'
// import CommentInput from '../../components/LikeComment/CommentInput';
// import { staticFiles } from '../../components/Helpers/Static';
// import { ActiveIconColor, BgWhite, TextGray } from '../Theme';
// import { MdDescription, MdKeyboardArrowLeft } from 'react-icons/md';
// import { tokenAuthorize } from '../../components/Helpers/Common';

// const FILE_UPLOAD = staticFiles.fileUpload;
// const NO_IMAGE = staticFiles.noImage;

// const AnnounceView = (props) => {

//     const history = useHistory();
//     const location = useLocation();

//     const groupId = location.state.id;

//     const { id } = useParams()
//     const userId = localStorage.getItem('user_id')
//     const userProfile = useSelector(state => state.auth.user)
//     const profile = {
//         name: userProfile ? userProfile.fullname : '',
//         photo: userProfile ? userProfile.photo : hmenu_user,
//     }

//     const [isLoad, setisLoad] = useState(false)
//     const [announcementTitle, setannouncementTitle] = useState("");
//     const [announcementDesc, setannouncementDesc] = useState("");
//     const [announcementAttachment, setannouncementAttachment] = useState([]);
//     const [announcementCreatedOn, setannouncementCreatedOn] = useState("");
//     const [announcementFullName, setannouncementFullName] = useState("");
//     const [guId, setguId] = useState("");

//     useEffect(() => {
//         setisLoad(true)
//         getAnnouncement();
//     }, [])

//     const goBack = () => {
//         history.goBack();
//     }

//     const getAnnouncement = () => {
//         return axios.get(
//             `${apiUrl}${groupId}/announcement/${id}`
//         ).then(resp => {
//             if (resp.status === 200) {
//                 let data = [];
//                 setannouncementAttachment(resp.data?.announcement_attachment)
//                 setannouncementDesc(resp.data?.announcement_desc)
//                 setannouncementTitle(resp.data?.announcement_title)
//                 setannouncementCreatedOn(resp.data?.announcement_created_on)
//                 setannouncementFullName(resp.data?.fullname)
//                 setguId(resp.data?.guid)
//             }
//             setisLoad(false)
//         }).catch(err => {
//             setisLoad(false)
//             tokenAuthorize(err?.response?.status);
//             if (err.response && (err.response.status === 404)) {
//                 history.push('/post-not-found');
//             }
//             else {
//                 console.log(err)
//             }
//         })
//     }
//     const minutesRead = announcementDesc ? readingTime(announcementDesc).text : null;
//     return (
//         <PageWrapper>
            
//             <BgWhite className="bg-white h-full w-11/12 flex flex-col container mx-auto pb-5">

//                 {isLoad ?
//                     <div className='w-full flex justify-center'>
//                         <img src={staticFiles.loading} alt='Loading...' className='w-10 h-10' />
//                     </div> :
//                     <>
//                         <div className="flex flex-col xl:w-3/4 mx-5 md:mx-28 lg:mx-40 xl:mx-68 mb-5 md:mb-10">
//                             <div className="flex flex-row items-center mt-10 mb-2 md:mb-5 ">
//                                 <MdKeyboardArrowLeft className='w-10 h-10 cursor-pointer back-icon' onClick={goBack} />
//                                 <p className="ml-3 xl:mr-40 text-4xl font-bold break-words w-full">{announcementTitle}</p>
//                             </div>
//                             <div className="flex flex-row lg:flex-row md:pt-3 mb-3 md:mb-5 ml-7 items-center relative ">
//                                 <div className="flex flex-col mr-10 text-left">
//                                     <Link
//                                         to={"/profile/" + guId}
//                                         target="_blank" rel="noopener noreferrer"
//                                         className="md:text-lg font-semibold break-words nav-navigate"
//                                     >
//                                         <ActiveIconColor className='hover:underline'>by {announcementFullName}</ActiveIconColor>
//                                     </Link>
//                                     <TextGray className="text-sm md:text-base font-normal">
//                                         {moment.utc(announcementCreatedOn).local().startOf('seconds').fromNow()} ({convertDate(announcementCreatedOn)}) - {minutesRead}
//                                     </TextGray>
//                                 </div>
//                             </div>

//                             {
//                                 announcementAttachment &&
//                                 announcementAttachment.map((item, idx) => {
//                                     let itemName = item ? item : null
//                                     if (itemName) {
//                                         const itemUrl = itemName;
//                                         const lastSlash = itemName.lastIndexOf('/');

//                                         if (lastSlash !== -1) {
//                                             itemName = itemName.substr(lastSlash + 1, itemName.length - lastSlash - 1)
//                                         }
//                                         return (
//                                             <div key={idx} className='flex flex-row items-center space-x-2 mt-2 mx-7 lg:mt-5"'>
//                                                 <MdDescription className='w-6 h-6' />
//                                                 <a
//                                                     href={itemUrl}
//                                                     target="_blank" rel="noopener noreferrer"
//                                                     className='hover:text-gray-800 cursor-pointer underline break-words nav-navigate'
//                                                 >
//                                                     <TextGray className='underline'>{itemName}</TextGray>
//                                                 </a>
//                                             </div>
//                                         )
//                                     }

//                                     return null;
//                                 })
//                             }

//                         </div>
//                         <div className="text-viewer mx-5 md:mx-32 lg:mx-48 xl:mx-60 my-5 break-words"
//                             dangerouslySetInnerHTML={{ __html: addAttribute(announcementDesc) }}
//                         />
//                     </>}

//                 {/* <hr className="self-center w-3/4 mx-10 lg:mx-40 rm" /> */}

//             </BgWhite>

//         </PageWrapper>
//     )
// }

// export default AnnounceView


